import React from "react";
import Contato from "../Contato/Contato";
import Fotos from "../Fotos/Fotos";
import Servicos from "../Serviços/Servicos";
import Sobre from "../Sobre/Sobre";
import "./Home.css";
import Videos from "../Videos/Videos";
import VIDEOHOME from "../../assets/videos/home.mp4";
import Footer from "../../shared/components/Footer/Footer";


const Home = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <>
      <div className="container p-5 home-container" id="home">
        <section className="row">
          <div className="col-lg-5 p-3">
            <h1 className="text-white">
              Já pensou em ter imagens de uma vista diferente ?
            </h1>
            <p className="text-white">
              Imagens aéreas, Filmagens Aéreas, Inspeção Predial e muito mais...
            </p>
            <a className="btn btn-lg btn-block botao-entrar " href="#contato">
              Fale Agora
            </a>
          </div>
          <div
            className="col-lg-6 home-youtube"
            style={{ display: matchResult ? "none" : "" }}
          >
            <video
              width="560"
              height="315"
              autoPlay="autoplay"
              plays-inline="true"
              muted
              loop
            >
              <source src={VIDEOHOME} type="video/mp4"></source>
            </video>
          </div>
        </section>
      </div>

      <Videos />
      <Fotos />
      <Servicos />
      <Sobre />
      <Contato />
      <Footer />
    </>
  );
};

export default Home;
